export default [
  {
    path: "/auth",
    name: "auth",
    component: () => import("../components/Auth.vue"),
    meta: {}
  },
  {
    path: "/user/:id",
    name: "user",
    component: () => import("../components/Profile.vue"),
    meta: {}
  }
]